import type { ListingListResponse } from '@proptr/shared';
import type { BannerListing } from '@proptr/creative-templates';

// One listing row -> the banner template's listing props.
//
// Extracted rather than inlined because three places render the same
// creative — the inline preview, the full-screen popup, and (through
// services/feedCreative.ts on the API side) the headless export. Two of
// those live in this app, and a mapping written twice is a mapping that
// drifts: the preview would quietly stop matching what ships.

type ListingRow = ListingListResponse['items'][number];

export function bannerListingFrom(l: ListingRow): BannerListing {
  return {
    imageUrl: l.image ?? null,
    // Rail photos for 9:16. Ignored at 1:1, and a listing with fewer than
    // three falls back to a full-bleed hero rather than rendering a
    // gap-toothed rail.
    gallery: l.gallery ?? null,
    imageAlt: l.title ?? '',
    // Derived from real data rather than invented — the feed has no
    // "new listing" signal to badge on.
    badge: l.forSale ? 'FOR SALE' : 'FOR RENT',
    locality: l.area ?? '',
    city: l.city ?? null,
    price: l.price ?? null,
    currency: l.currency ?? 'AED',
    locale: 'en-AE',
    // Strings, per the contract — feeds carry "Studio", "6+".
    beds: l.bedrooms == null ? null : String(l.bedrooms),
    baths: l.bathrooms == null ? null : String(l.bathrooms),
    // Listings carry no floor area yet; the column omits itself.
    area: null,
    areaUnit: 'sqft',
    permitQr: l.permitQr ?? null,
  };
}
